import axios from 'axios';
import React from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router';
import useAuth from '../hooks/useAuth';
import MenuBar from '../shared/MenuBar/MenuBar';

const Order = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const {user} = useAuth();
    const { register, handleSubmit, reset } = useForm();
    const onSubmit = data => {
        console.log(data);
        data.email = user.email;
        data.packageId = id;
        data.status = "pending";
        axios.post('https://eventmakerserver.herokuapp.com/orders', data)
            .then(res => {
                if (res.data.insertedId) {
                    toast.success('Address Successfully Uploaded! Please Pay Now')
                    reset();
                }
            })
            .then(navigate('/'))
    }
    return (
        <div className="order-page py-5">
            <MenuBar/>
        <h2 className="text-center pt-5">EVENT ADDRESS</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-main" style={{ borderRadius: "15px", maxWidth: '85rem' }}>
                <Row>
                    <Col style={{ width: '550px', margin: '0 auto' }} md={12} xs={12} className="pr-md-4">
                        <Row>
                            <Col md={6} sm={12}>
                                <input
                                    className="our-form-input"
                                    type="text"
                                    defaultValue=""
                                    {...register("name", { required: true })}
                                    placeholder="Name"
                                />
                            </Col>
                            <Col md={6} sm={12}>
                                <input
                                    type="number"
                                    className="our-form-input"
                                    defaultValue=""
                                    {...register("phone", { required: true })}
                                    placeholder="10-digit mobile number"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6} sm={12}>
                                <input
                                    className="our-form-input"
                                    type="text"
                                    defaultValue=""
                                    {...register("pincode", { required: true })}
                                    placeholder="Pincode"
                                />
                            </Col>
                            <Col md={6} sm={12}>
                                <input
                                    className="our-form-input"
                                    type="text"
                                    defaultValue=""
                                    {...register("locality")}
                                    placeholder="Locality"
                                />
                            </Col>
                        </Row>
                        <textarea
                            type="textarea"
                            style={{ height: '150px' }}
                            className="our-form-input"
                            defaultValue=""
                            {...register("fullAddress", { required: true })}
                            placeholder="Address (Area and Street)"
                        />
                        <br />
                        {/* <Button type="submit">Send</Button> */}
                    </Col>
                </Row>
            </div>

            <div className="text-center mt-4">
                <Button type="submit" className="btn-main" style={{ padding: ".68rem 2rem" }}>
                    SAVE AND CONTINUE
                </Button>
            </div>
            <Toaster />
        </form>
    </div>
    );
};

export default Order;